'use client';
import { useEffect } from 'react';
import { useMediaQuery } from './useMediaQuery';

const useBodyScrollLock = (isLocked: boolean): void => {
  const { isTablet, isMobile } = useMediaQuery();
  const isMobileOrTablet = isTablet || isMobile;

  useEffect(() => {
    if (!isMobileOrTablet) return;

    if (isLocked) {
      const scrollY = window.scrollY;
      
      document.body.classList.add('dropdown-open');
      
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.classList.remove('dropdown-open');
      
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY, 10) * -1);
      }
      
    }
    
    return () => {
      document.body.classList.remove('dropdown-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
    };
  }, [isLocked, isMobileOrTablet]);
};

export default useBodyScrollLock;